import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import Inboxheader from "../../../../src/components/Common/Navigation/Header/InboxHeader";
import SideMenuWrapper from "../../../../src/components/Common/Navigation/SideMenu/SideMenuWrapper";
import { getHeaderTitleFromPath } from "../../../../src/helper/HelperFunctions";
import { ApplicationState } from "../../../../src/store";
import { getLeftSideMenuData } from "../../../../src/actionCreators/commonActionCreators";
import { fetchUserOwnedFolders } from "../../../../src/actionCreators/folderActionCreators";
import { getDocumentCategoriesDropdown } from "../../../../src/actionCreators/documentCategoryActionCreator";
import * as OfficeHelpers from "@microsoft/office-js-helpers";
import { injectPendoScript } from "../../../../src/components/Common/Pendo/Pendo";


declare global {
    interface Window {
        pendo: any;
    }
}

interface ILayoutProps {
    children?: React.ReactNode;
}

const InboxLayout: React.FC = (props: ILayoutProps) => {
    const location = useLocation();
    const [showSideMenu, toogleSideMenu] = useState(false);
    const [headerTitle, setheaderTitle] = useState("Inbox");
    const { mailboxUserData } = useSelector((state: ApplicationState) => state.commonState);
    const dispatch = useDispatch();
    const userAuth = useSelector((state: ApplicationState) => state.userAuth.user);
    const { isTestCompany } = useSelector((state: ApplicationState) => state.postAuthState);


    useEffect(() => {
        dispatch(getLeftSideMenuData());
        dispatch(getDocumentCategoriesDropdown());
    }, []);

    useEffect(() => setheaderTitle(getHeaderTitleFromPath(location.pathname)));
    
    useEffect(() => {
        dispatch(fetchUserOwnedFolders());  
    }, [mailboxUserData]);
    
    useEffect(()=>{
        if(userAuth?.profile){
            injectPendoScript(userAuth, isTestCompany);
            }
    },[userAuth?.profile]);

    return (
        <div
            className={`inbox-wrapper flex-coloumn ${
                Office.context.diagnostics.platform === Office.PlatformType.OfficeOnline ? "ml-10" : ""
            }`}
        >
            <Inboxheader showSideMenuHandler={() => toogleSideMenu(true)} headerTitle={headerTitle} />
            <SideMenuWrapper showSideMenu={showSideMenu} closeSideMenuHandler={() => toogleSideMenu(false)} />
            <div
                style={{
                    marginTop: mailboxUserData ? "2%" : 0,
                }}
                className="fixed-height-wapper"
            >
                {props.children}
            </div>
        </div>
    );
};

export default InboxLayout;
